import Appsignal from '@appsignal/javascript'

const appsignal = new Appsignal({ key: process.env.APP_SIGNAL_KEY })

export default appsignal



// WEBPACK FOOTER //
// ./src/utils/signal.js